import React from "react";
import get from "lodash/get";

export const renderCell = (
  { component: Component, render, dataIndex },
  rowData,
  rowIndex,
  onSelectRowHandler,
  isChecked
) => {
  if (typeof Component === "function") {
    return <Component row={rowData} rowIndex={rowIndex} />;
  } else if (typeof render === "function") {
    return render({
      rowData,
      isChecked,
      onSelectRowHandler,
      rowIndex,
    });
  }
  return dataIndex ? get(rowData, dataIndex) : "";
};

export const checkboxColumn = {
  renderHeader: ({ selectedAll, onSelectAllHandler }) => (
    <input
      type="checkbox"
      onChange={onSelectAllHandler}
      checked={selectedAll}
      className="mydpd-checkbox"
    />
  ),
  render: ({ rowData, isChecked, onSelectRowHandler }) => (
    <input
      type="checkbox"
      onChange={onSelectRowHandler(rowData)}
      checked={isChecked(rowData)}
      className="mydpd-checkbox"
    />
  ),
  text: "checkbox",
  style: {
    width: "35px",
  },
};
